const styles = ((theme) => ({
  resultPageInputs: {
    display: "flex",
    justifyContent: "flex-start"

  },
  root: {
    width: '100%',
  },

  divider: {
    paddingTop: '50px',
  },
  spacing: {
    marginBottom: '10px'
  },

  centered: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  widenDivider: {
    width: "3px"
  },
  searchBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  searchFormMargin: {
    marginBottom: "10px"
  }
}))

export default styles;